import React from 'react'
import Pagetitle from './component/Pagetitle'
import { Link } from 'react-router-dom'

function ShippingDelivery() {
  return (
    <>
    <Pagetitle title="Shipping & Delivery"/>
    <section className="flat-spacing-25">
            <div className="container">
                <div className="tf-main-area-page tf-page-delivery">
                    <div className="box">
                        <h4>Delivery</h4>
                        <p>All orders shipped with UPS Express.</p>
                        <p>Always free shipping for orders over INR ₹5000.</p>
                        <p>All orders are shipped with a UPS tracking number.</p>
                    </div>
                    <div className="box">
                        <h4>Returns</h4>
                        <p>Items returned within 14 days of their original shipment date in same as new condition will be eligible for a full refund or store credit.</p>
                        <p>Refunds will be charged back to the original form of payment used for purchase.</p>
                        <p>Customer is responsible for shipping charges when making returns and shipping/handling fees of original purchase is non-refundable.</p>
                        <p>All sale items are final purchases.</p>
                    </div>
                    <div className="box">
                        <h4>Help</h4>
                        <p>Give us a shout if you have any other questions and/or concerns.</p>
                        <p>Email: <Link to="mailto:info@geniusbaby.com" className="cf-mail">info@geniusbaby.com</Link></p>
                        <p>Phone: (+91) 808-037-7402</p>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default ShippingDelivery